import { useDeviceWidth } from 'app/hooks/use-device-size';
import type { NavigationScreen } from 'app/types/navigation';
import { Platform, View } from 'react-native';
import { InterestsScreenBody } from './interests-screen-body';
import { useInterestsScreen } from './use-interests-screen';

export const InterestsScreenSmall: NavigationScreen<'interests'> = ({ navigation, route }) => {
  const itemWidth = useDeviceWidth();
  const screenState = useInterestsScreen({
    navigation,
    route,
    itemWidth,
    webAggregateListingSteps: Platform.OS === 'web',
    webListingLayout: Platform.OS === 'web' ? 'small' : undefined,
  });

  if (screenState.carouselItems.length === 0) {
    navigation.goBack();
    return null;
  }

  return (
    <View style={{ flex: 1 }}>
      <InterestsScreenBody {...screenState} />
    </View>
  );
};
